import React from "react";
import cssModuleClassNames from "classnames/bind";
import styles from "./multi-step.module.css";

const classNames = cssModuleClassNames.bind(styles);

interface Props {
  stepTitles: React.ReactNode[];
  currentStepNumber: number;
  className?: string;
}

/** Display progress through a multi step checkout flow
 *  The current step number assumes it is 0 indexed
 *
 *  Example:
 *
 * ```
 *  <MultiStepProgress
 *    currentStepNumber={2}
 *    stepTitles={[ "View Cart", "Select Shipping", "Confirm Payment" ]}
 *  />
 * ```
 */
const MultiStepProgress: React.FC<Props> = ({ stepTitles, currentStepNumber, className }) => {
  const currentStepTitle = stepTitles[currentStepNumber];
  return (
    <div className={className}>
      <div className={styles.progressItemContainer}>
        {stepTitles.map((_, i) => (
          <div
            key={i}
            className={classNames(styles.progressItem, { active: currentStepNumber >= i })}
          />
        ))}
      </div>
      <span className={styles.title}>
        STEP {currentStepNumber + 1}: {currentStepTitle}
      </span>
    </div>
  );
};

export default MultiStepProgress;
